import { queryOptions } from "@tanstack/react-query";
import { apiGet, apiPost } from "@amber/ui";
import { backfillPreviewSchema, okResultSchema } from "../../contracts/index";
import { collectionKeys } from "./keys";

export const gapCommands = {
  backfill: (id: string, body: { reason: string }, csrf: string | null) =>
    apiPost(`/api/collection/gaps/${encodeURIComponent(id)}/backfill`, body, okResultSchema, csrf),
  cancelBackfill: (id: string, body: { reason: string }, csrf: string | null) =>
    apiPost(`/api/collection/gaps/${encodeURIComponent(id)}/cancel-backfill`, body, okResultSchema, csrf),
  nextStep: (
    id: string,
    body: { next_step: "automatic_retry" | "wait_for_source" | "accept_as_permanent"; note: string; reason: string },
    csrf: string | null,
  ) => apiPost(`/api/collection/gaps/${encodeURIComponent(id)}/next-step`, body, okResultSchema, csrf),
  resolve: (id: string, body: { note: string }, csrf: string | null) =>
    apiPost(`/api/collection/gaps/${encodeURIComponent(id)}/resolve`, body, okResultSchema, csrf),
};

export const backfillPreviewQuery = (gapId: string) =>
  queryOptions({
    queryKey: collectionKeys.backfillPreview(gapId),
    queryFn: ({ signal }) =>
      apiGet(`/api/collection/gaps/${encodeURIComponent(gapId)}/backfill-preview`, backfillPreviewSchema, signal),
  });
